import { usePromisedRequest as promiseRequest } from "../../Common/request";
import { resolveWithBody, resolveWithAccepted } from "../Utils/utils";

export type ExtractionStatus = "initiated" | "inProgress" | "done" | "failed";

export type CategoriesExtraction = {
    id: string;
    eventId: number;
    status: ExtractionStatus;
    created: string;
    updated: string;
    hasExtractedCategories: boolean;
    extractedCategories?: string | null;
};

export type CategoriesExtractionPreview = {
    id: string;
    eventId: number;
    status: ExtractionStatus;
    created: string;
    updated: string;
    hasExtractedCategories: boolean;
    extractedCategories: string[];
};

export type InitExtractionResult = {
    id: string;
};

export type InitExtractionRequest = {
    eventId: number;
    sourceText: string;
};

export type ImportExtractionResult = {
    importedCategories: number;
    totalPersistedParameters: number;
    duplicatesFound: number;
};

export default {
    getExtractions(eventId: number): Promise<CategoriesExtractionPreview[]> {
        return promiseRequest<CategoriesExtractionPreview[]>({
            url: `/api/events/${eventId}/categories-extraction`,
            json: true,
            method: "get",
        }).then(resolveWithBody());
    },

    getExtraction(eventId: number, extractionId: string): Promise<CategoriesExtraction> {
        return promiseRequest<CategoriesExtraction>({
            url: `/api/events/${eventId}/categories-extraction/${extractionId}`,
            json: true,
            method: "get",
        }).then(resolveWithBody());
    },

    initiateExtraction(request: InitExtractionRequest): Promise<InitExtractionResult> {
        return promiseRequest<InitExtractionResult>({
            url: `/api/events/${request.eventId}/categories-extraction`,
            method: "post",
            json: request,
        }).then(resolveWithAccepted("Could not initiate extraction."));
    },

    importExtraction(eventId: number, extractionId: string, branchName?: string): Promise<ImportExtractionResult> {
        return promiseRequest<ImportExtractionResult>({
            url: `/api/events/${eventId}/categories-extraction/${extractionId}/actions/import`,
            method: "post",
            json: branchName ? { branchName } : {},
        }).then(resolveWithBody());
    },
};
